import React from "react";

const steps = [
  {
    n: "01",
    title: "Strategy Sync",
    body:
      "A short call on Zoom or Teams to align on your practice's advice philosophy and template requirements. As a senior paraplanner who has delivered 1,100+ documents, I make sure our first file is a perfect fit.",
  },
  {
    n: "02",
    title: "Optional NDA & SLA",
    body:
      "Your call. If you want paperwork in place we sign one mutual NDA and one SLA at the start, and those govern the entire engagement, not file by file. You then grant secure access to your Xplan or Xtools+ instance. No client data leaves your secure cloud environment. Zero local data retention.",
  },
  {
    n: "03",
    title: "Brief & Automated Analysis",
    body:
      "You share the Fact Find. I run it through multiple AI models alongside custom Excel macros to process tax data and cashflow variables with extreme accuracy. Cross checking across models removes manual error risk and outpaces traditional BPO data entry.",
  },
  {
    n: "04",
    title: "Advanced Strategy Modeling",
    body:
      "I model the complex scenarios. SMSFs, LRBAs, Family Trusts, gearing. Every recommendation meets Best Interests Duty (BID) and ASIC RG90 standards before it leaves my desk.",
  },
  {
    n: "05",
    title: "QA & Delivery",
    body:
      "Every document goes through a rigorous internal audit. You receive a final, audit ready SOA or ROA within the agreed timeframe, ready for immediate client presentation.",
  },
];

const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-white border-b-2 border-black"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <div className="max-w-3xl">
          <span className="inline-block bg-[#FACC15] border-2 border-black px-3 py-1 text-xs font-bold uppercase tracking-widest shadow-brutal">
            The Banana Paraplanner Workflow
          </span>
          <h2 className="font-display font-black mt-4 text-4xl md:text-5xl tracking-tighter leading-[1.05]">
            First contact to final delivery. Transparent, secure, efficient.
          </h2>
          <p className="mt-5 text-base md:text-lg text-black/75 leading-relaxed">
            Every step is timestamped, version controlled, and accountable. No queues, no relay tickets.
            Just SOAs that ship.
          </p>
        </div>

        <ol className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-8 relative">
          {steps.map((s, i) => (
            <li
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className="relative bg-white border-2 border-black p-6 shadow-brutal hover-lift"
            >
              <div className="absolute -top-3 -right-3 bg-[#FACC15] border-2 border-black px-2 py-1 text-[10px] font-bold uppercase tracking-widest">
                Step
              </div>
              <span
                className="block font-display font-black text-7xl text-[#FACC15] leading-none select-none"
                aria-hidden
              >
                {s.n}
              </span>
              <h3 className="font-display font-bold text-xl mt-3">{s.title}</h3>
              <p className="text-sm text-black/75 mt-2 leading-relaxed">{s.body}</p>
              {i < steps.length - 1 && (
                <span
                  className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-black"
                  aria-hidden
                />
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Process;
